// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1616":"76ee0df3ced07674","4605":"bddc0a1f95c5f8d2"}[chunkId] + ".js";
};